import { Injectable } from '@angular/core';


@Injectable()
export class Utils  {

    serviceNames = {
        1: 'Employer of Record',
        2: 'Agent of Record',
        3: 'Compliance'
    };

    serviceShortNames = {
        1: 'EOR',
        2: 'AOR',
        3: 'COM'
    };

    constructor() {
    }

    getDefaultDateRange(instanceName: any): any {
        const date = new Date();
            // var start = new Date(date.getFullYear, date.getMonth(), 1);  // go back to first of current month
            // var start = new Date(date.getFullYear()-1, 0, 1);
            // go back to First of the year -- FOR DEMO ONLY!!!!!! go back to start of pervious year
            // var start = new Date(date.getFullYear(), 0, 1);  // go back to First of the year - eee 6/4/2019
            // var end = new Date(date.getFullYear(), 11, 31);

            // var start = new Date(date.getFullYear(), date.getMonth(), 1);  // go back to first of current month

        let start = new Date(date.getFullYear(), 0, 1);  // go back to First of the year
        let end = new Date(date.getFullYear(), 11, 31); // go back to End of the year
        
        // commented this block as we are not going to retain selected values across screens, 
        // within the screens the data is getting passed in url
        // if (instanceName) {
        //         const filters = this.getSessionFilter(instanceName);

        //         if (filters && filters.start && filters.end) {
        //             start = new Date(filters.start);  // go back to previously selected
        //             end = new Date(filters.end); // go back to previously selected
        //         }
        //     }

            // var end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return {
                start,
                end
            };
    }

    getSessionFilter = (instanceName) => {
        return JSON.parse(sessionStorage.getItem('Cilent_Filter_' + instanceName));
    }

    setSessionFilter = (instanceName, filters) => {
        sessionStorage.setItem('Cilent_Filter_' + instanceName, JSON.stringify(filters));
    }


    getServiceName = (serviceId) => {
        return this.serviceNames[serviceId];
    }

    getServiceShortName = (serviceId) => {
        return this.serviceShortNames[serviceId];
    }
    htmlDecode(str): string {
        var div = document.createElement("div");
        div.innerHTML = str;
        return div.textContent || div.innerText;
    }
}
